import { jsx as _jsx } from "react/jsx-runtime";
import NOB from 'constants/language-strings';
import { SearchProductBar } from 'components/search-product/search-product-bar';
import { useAvailableProducts } from 'modules/CustomerProducts/api';
import { SlideInModal } from 'components/slide-in-modal';
import { ErrorNotification } from 'components/error-notification/error-notification';
export const AddProduct = ({ agreementId, customerId, addProduct, isVisible, onClose, }) => {
    const { availableProducts, isAvailableProductsFetching, availableProductsErrorMessage, } = useAvailableProducts(agreementId);
    const addNewProduct = (product) => {
        addProduct({ agreementId, customerId, product });
        onClose();
    };
    return (_jsx(SlideInModal, { display: isVisible, onClose: onClose, mainHeading: "Legg til produkter", isFetching: isAvailableProductsFetching, children: availableProductsErrorMessage ? (_jsx(ErrorNotification, { title: NOB.ADD_PRODUCT.ERROR_MESSAGE_FETCHING_PRODUCTS, text: availableProductsErrorMessage })) : (_jsx(SearchProductBar, { options: availableProducts || [], onChange: addNewProduct })) }));
};
